import React from 'react';
import { Modal, Typography } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { useFelaEnhanced } from 'hooks';
import * as felaRules from './DocumentUploadModal.rules';
import { SeoHead } from 'modules/seo';
import { GeneralUpload } from 'modules/documents/components/GeneralUpload';
import { useDocumentProcessing } from './DocumentProcessingContext';

export const DocumentUploadModal = () => {
    const { styles } = useFelaEnhanced(felaRules);
    const {
        showDocumentUploadModal,
        setShowDocumentUploadModal,
        fetchDocuments,
        tabKey,
        filterOptions,
        getDocumentTypeBaseOnTabKey,
        setLandingPageRefreshToken,
    } = useDocumentProcessing();
    const intl = useIntl();

    return (
        <Modal
            footer={null}
            visible={showDocumentUploadModal}
            onCancel={() => setShowDocumentUploadModal(false)}
      >
            <div className={styles.container}>
                <SeoHead title={intl.formatMessage({ id: 'documents.generalUpload.seoTitle' })} />
                <Typography.Title level={2} className={styles.title}>
                    <FormattedMessage id="documents.generalUpload.title" />
                </Typography.Title>
                <Typography.Paragraph type="secondary" className={styles.description}>
                    <FormattedMessage id="documents.generalUpload.description" />
                </Typography.Paragraph>
                <GeneralUpload hideModal={() => setShowDocumentUploadModal(false)} onUploadSuccess={() => {
                  // Refresh whichever tab is actually visible — fetchDocuments()
                  // with no args always refetched the Pending tab's 'extractions'
                  // list regardless of what was uploaded or which tab was open.
                  if (tabKey === '6') {
                    setLandingPageRefreshToken(token => token + 1);
                  } else {
                    fetchDocuments(getDocumentTypeBaseOnTabKey(tabKey), filterOptions);
                  }
                  setShowDocumentUploadModal(false);
                }} />
            </div>
        </Modal>
       
    );
};
